<atomic-name-badge
	[bold]="true"
	[initials]="initials$ | async"
	size="small"
	[matMenuTriggerFor]="card"
	class="cursor-pointer"
	[class.opened]="menuOpened$ | async"
	(menuOpened)="onMenuOpen()"
	(menuClosed)="onMenuClose()"
></atomic-name-badge>

<mat-menu #card="matMenu">
	<ng-template matMenuContent>
		<ng-container *ngIf="contact$ | async as contact">
			<div
				class="text-sm text-grey-darker grid gap-y-2 gap-x-3 pb-4 pt-2 px-4"
				style="grid-template-columns: min-content 1fr"
			>
				<ng-container *ngIf="!!heading">
					<div></div>
					<div style="font-weight: 900">{{ heading }}</div>
				</ng-container>

				<div></div>
				<div class="font-bold">{{ contact | clientName | capitalize }}</div>

				<ng-container *ngIf="lawFirm?.name">
					<div></div>
					<div>{{ lawFirm?.name }}</div>
				</ng-container>

				<app-icon [icon]="ICON.EMAIL"></app-icon>
				<div>
					<ng-container *ngIf="contact?.email; else na"
						><a
							emailLinkInterceptor
							[mailto]="contact.email"
							class="underline"
							>{{ contact.email }}</a
						></ng-container
					>
				</div>

				<app-icon [icon]="ICON.PHONE"></app-icon>
				<div>
					<ng-container *ngIf="contact?.phone; else na">
						<a
							externalNavInterceptor
							target="_blank"
							href="tel:{{ contact.phone }}"
							class="underline"
							>{{ contact.phone }}</a
						>
						<!-- @@todo - extension support -->
					</ng-container>
				</div>
			</div>
		</ng-container>
	</ng-template>
</mat-menu>

<ng-template #na>
	<span class="text-grey-light font-bold text-sm">NA</span>
</ng-template>
